<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onDelete="() => {}"
    :onUpdate="() => {}"
    :onStore="() => {}"
    :enableSearch="true"
    :checkAlerts="true"
    :formInputs="formInputs"
    primaryKey="id"
  />
</template>

<script>
import CrudBase from '../../../components/crud/CrudBase';
import { yesNoRepresentation } from '@/helpers/transformers';

export default {
  name: 'operacao-plano',
  components: { CrudBase },
  data() {
    return {
      url: '/admin/condicoes/operacao-plano',
      columns: [
        { label: 'ID', field: 'id', sortable: false },
        {
          label: 'Operação',
          field: 'operacao',
          sortable: false,
          representedAs: (row) =>
            row?.operacao
              ? `${row.operacao_id} - ${row.operacao.descricao}`
              : row.operacao_id,
        },
        {
          label: 'Plano de Pagamento',
          field: 'plano_pagamento',
          sortable: false,
          representedAs: (row) =>
            row?.plano_pagamento
              ? `${row.planopagamento_id} - ${row.plano_pagamento.descricao}`
              : row.planopagamento_id,
        },
        {
          label: 'Ativo',
          field: 'ativo',
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: {
          type: 'string',
          ui: {
            label: 'Identificador',
            columns: 4,
            widget: 'AutoIdWidget',
            widgetConfig: { campo1Key: 'operacao_id', campo2Key: 'planopagamento_id' },
          },
          rules: { required: { value: true, errMsg: 'Preencha o Identificador.' } },
        },
        operacao_id: {
          type: 'number',
          ui: {
            label: 'Operação',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/condicoes/operacoes',
              idField: 'id',
              labelField: 'descricao',
              preload: true,
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        planopagamento_id: {
          type: 'number',
          ui: {
            label: 'Plano de Pagamento',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/condicoes/planos',
              idField: 'id',
              labelField: 'descricao',
              preload: true,
              extraParams: { ativo: 1 },
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        ativo: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Ativo',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
      },
    };
  },
};
</script>
